<template lang="html">
  <div id="reschedulingSenderForm">
    <h1 class="header">授業振替依頼をする</h1>
    <div v-if="check_tankiuser()">
      <div class="messagetext">
        <span class="box-title">注意事項</span>
        <a>恐れ入りますが、短期コースを受講されている方は振替機能をご利用いただけません。<br>
          振替をご希望の方は究進塾事務局(info@kyushinjuku.com)へ、<br>
          授業前日22時までにご連絡ください。</a>
      </div>
    </div>
    <div v-if="!check_tankiuser()">
      <!--振替したい授業を選択する部分-->
      <section
        id="first-section"
        class="section"
      >
        <h1 class="section-description"><span class="step-section">STEP 1</span> : &ensp;&ensp;振替を希望する授業を以下のリストから選択してください</h1>

        <!--入力チェックの通知-->
        <div
          v-if="isCompletenessChecking && !selectedReservation && !isOther"
          key="warning-first-unselected"
        >
          <notificationBox
            class="notificationBox"
            type='warning'
            text="振替を希望する授業を選択してください"
          />
          <!--
          <notificationBox
            class="notificationBox"
            type='warning'
            text="リストにない場合は「上記以外の授業」を選択してください"
          />
        -->
        </div>
        <notificationBox
          v-else-if="isCompletenessChecking && !isFirstCompleted"
          key="warning-first-unspecified"
          class="notificationBox"
          type='warning'
          style="margin-top: 20px;"
          text="授業の情報を全て指定してください"
        />
        <notificationBox
          v-else-if="isCompletenessChecking && isFirstCompleted"
          key="ok-first"
          class="notificationBox"
          type='ok'
          style="margin-top: 10px;"
          text="正しく入力されています"
        />
        <!--入力チェックの通知 終わり-->

        <!--現在の予約のリスト-->
        <div style="margin-top: 20px;">授業数：{{ reservations.length }}件</div>
        <ul id="reservation-list">
          <li
            v-for="(reservation, index) in reservations"
            :key="'reservation' + index"
            class="list-item list-item-reservation"
          >
            <input
              :id="'list-item-reservation-radio' + index"
              v-model="selectedReservation"
              type="radio"
              :value="reservation"
              :disabled="isOther||reservation.expireCheck"
              @change="reservationChanged()"
            >
            <label v-if="!reservation.expireCheck" :for="'list-item-reservation-radio' + index">{{ reservation.text }}</label>
            <label v-else="reservation.expireCheck"
                   :for="'list-item-reservation-radio' + index"
                   style="color: #989898"
                   @click="alert('授業振替ではなく授業キャンセルとなるので、別途究進塾にご連絡（電話orメール）ください')"
                   >{{ reservation.text }}  期限切れです</label>
          </li>
        </ul>
        <!--現在の予約のリスト 終わり-->
        <!--その他の予約指定-->
        <input
          id="otherCheck"
          v-model="isOther"
          type="checkbox"
          @change="reservationChanged()"
        >
        <label for="otherCheck">上記以外の授業</label>
        <div
          v-if="isOther"
          id="other-reservation-box"
          key="other-reservation"
        >
          <!--生徒または講師指定部分-->
          <div
            v-if="$store.state.userInfo.user_type === 'teacher'"
            key="select-student">
            <label>生徒のお名前：</label>
            <autocomplete
              v-model="otherReservation.receiver"
              :suggestions="studentList"
            />
          </div>
          <div
            v-else-if="$store.state.userInfo.user_type === 'student'"
            key="select-teacher">
            <label>先生のお名前：</label>
            <autocomplete
              v-model="otherReservation.receiver"
              :suggestions="teacherList"/>
          </div>
          <!--生徒または講師指定部分 終わり-->
          <!--日付指定部分-->
          <div>
            <label>日付：</label>
            <el-date-picker
              v-model="otherReservation.date"
              placeholder="日付を選択"
              :format="'yyyy年MM月dd日(' + getWeekday(new Date(otherReservation.date)) + ')'"
              value-format="yyyy-MM-dd"
              :picker-options="{disabledDate: disabledDate}"
              style="width: 190px;"
            />
          </div>
          <!--日付指定部分 終わり-->
          <!--開始時刻・終了時刻指定部分-->
          <div>
            <label>時間：</label>
            <el-time-select
              v-model="otherReservation.startTime"
              placeholder="開始時刻を選択"
              :picker-options="{
                start: '10:00',
                end: '23:00',
                step: '00:05',
                maxTime: otherReservation.endTime,
              }"
              style="width: 160px;"
            />
            <label> 〜 </label>
            <el-time-select
              v-model="otherReservation.endTime"
              placeholder="終了時刻を選択"
              :picker-options="{
                start: '10:00',
                end: '23:00',
                step: '00:05',
                minTime: otherReservation.startTime
              }"
              style="width: 160px;"
            />
            <!--開始時刻・終了時刻指定部分 終わり-->
          </div>
        </div>
        <!--その他の予約指定 終わり-->
        <div class="messagetext">
          <span class="box-title">注意事項</span>
          <p>振替依頼は、必ず授業前日22:00までに完了してください。</p>
          <p>それ以降は振替依頼をすることが出来ません。</p>
          <p>授業前日22:00を過ぎた場合は振替ではなくキャンセルとなりますので、</p>
          <p>お電話またはメールにて事務局までご連絡ください。</p>
          <p>TEL:03-5927-1660 (日曜/年末年始を除く13:00-21:00)</p>
          <p>MAIL : info@kyushinjuku.com</p>
        </div>
      </section>
      <!--振替したい授業を選択する部分 終わり-->

      <!--振替候補日時を指定する部分-->
      <section
        id="second-section"
        class="section"
      >
        <h1 class="section-description"><span class="step-section">STEP 2</span> : &ensp;&ensp;振替候補日時を指定してください</h1>

        <!--入力チェックの通知-->
        <notificationBox
          v-if="!isFirstCompleted"
          key="warning-second-uncompleted-first"
          class="notificationBox"
          type="warning"
          style="margin-top: 20px;"
          text="候補日時を指定する前に振替を希望する授業を選択してください"
        />
        <notificationBox
          v-else-if="isCompletenessChecking && !isSecondCompleted"
          key="warning-second-unspecified"
          class="notificationBox"
          type="warning"
          style="margin-top: 20px;"
          text="全ての候補日時の日付、開始時刻，終了時刻を指定してください"
        />
        <notificationBox
          v-else-if="isCompletenessChecking && isSecondCompleted"
          key="ok-second"
          class="notificationBox"
          type="ok"
          style="margin-top: 10px;"
          text="正しく入力されています"
        />
        <!--入力チェックの通知 終わり-->

        <div
          v-if="isFirstCompleted"
          key="candidate-list"
        >
          <!--候補日時のリスト-->
          <ul id="candidate-list">
            <li
              v-for="(cand, index) in candidateDatetimes"
              :key="'list-item-candidate' + index"
              class="list-item list-item-candidate"
            >
              <!--1つの候補日時ボックス-->
              <div class="candidate-box">
                <!--ボックスの見出し-->
                <div class="candidate-caption">
                  <div class="candidate-caption-label">
                    <label>候補 {{ index + 1 }}</label>
                  </div>
                  <div class="candidate-caption-button">
                    <el-button
                      class="btn"
                      icon="el-icon-close"
                      :style="{visibility: (candidateDatetimes.length > 1) ? 'visible' : 'hidden'}"
                      @click="deleteCandidate(index)"
                    />
                  </div>
                </div>
                <!--ボックスの見出し 終わり-->
                <!--日付指定部分-->
                <div class="candidate-content">
                  <label>日付：</label>
                  <el-date-picker
                    v-model="cand.date"
                    placeholder="日付を選択"
                    :format="'yyyy年MM月dd日(' + getWeekday(new Date(cand.date)) + ')'"
                    value-format="yyyy-MM-dd"
                    :picker-options="{
                      disabledDate: disabledDate
                    }"
                    style="width: 190px;"
                  />
                </div>
                <!--日付指定部分 終わり-->
                <!--時間指定方法選択部分-->
                <div class="candidate-content">
                  <label>時間：</label>
                  <input
                    :id="'radio-slot-mode' + index"
                    v-model="cand.mode"
                    type="radio"
                    value="slot"
                    @change="cand.startTime = null; cand.endTime = null"
                  >
                  <label :for="'radio-slot-mode' + index">1コマ分を指定</label>
                  <input
                    :id="'radio-range-mode' + index"
                    v-model="cand.mode"
                    type="radio"
                    value="range"
                    @change="cand.startTime = null; cand.endTime = null"
                  >
                  <label :for="'radio-range-mode' + index">範囲で指定</label>
                </div>
                <!--時間指定方法選択部分 終わり-->
                <!--時間指定部分-->
                <div class="candidate-content">
                  <el-time-select
                    v-model="cand.startTime"
                    placeholder="開始時刻を選択"
                    :picker-options="{
                      start: '10:00',
                      end: '23:00',
                      step: '00:05',
                      maxTime: getMaxStartTime(cand)
                    }"
                    style="width: 160px;"
                    @change="candidateStartTimeChanged(cand)"
                  />
                  <label> 〜 </label>
                  <el-time-select
                    v-model="cand.endTime"
                    placeholder="終了時刻を選択"
                    :picker-options="{
                      start: '10:00',
                      end: '23:00',
                      step: '00:05',
                      minTime: getMinEndTime(cand)
                    }"
                    style="width: 160px;"
                    @change="candidateEndTimeChanged(cand)"
                  />
                  <label
                    v-if="cand.mode === 'slot'"
                    key="slot-mode"
                  >
                    の1コマ
                  </label>
                  <label
                    v-else-if="cand.mode === 'range'"
                    key="range-mode"
                  >
                    の中で{{ reservationDuration }}分間
                  </label>
                </div>
                <!--時間指定部分 終わり-->
              </div>
              <!--1つの候補日時ボックス 終わり-->
            </li>
          </ul>
          <!--候補日時のリスト 終わり-->
          <el-button
            class="btn"
            @click="addEmptyCandidate()"
          >
            ＋ 候補日時を追加する
          </el-button>
        </div>
      </section>
      <!--振替候補日時を指定する部分　終わり-->

      <!--振替理由を記入する部分-->
      <section
        id="third-section"
        class="section"
      >
        <h1 class="section-description"><span class="step-section">STEP 3</span> : &ensp;&ensp;振替を希望する理由を入力してください（必須）</h1>

        <!--入力チェックの通知-->
        <notificationBox
          v-if="isCompletenessChecking && !isThirdCompleted"
          key="warning-third"
          type="warning"
          style="margin-top: 20px;"
          text="理由は必須項目です"
        />
        <notificationBox
          v-else-if="isCompletenessChecking && isThirdCompleted"
          key="ok-third"
          type="ok"
          style="margin-top: 10px;"
          text="正しく入力されています"
        />
        <!--入力チェックの通知 終わり-->

        <div class="text-area">
          <el-input
            v-model="reason"
            type="textarea"
            placeholder="理由を入力してください"
            rows="3"
          />
        </div>
      </section>
      <!--振替理由を記入する部分　終わり-->

      <!--（教師の場合のみ）授業のオプションを指定する部分-->
      <section
        v-if="$store.state.userInfo.user_type === 'teacher'"
        id="fourth-section"
        key="fourth-section"
      >
        <!--入力チェックの通知-->
        <h1 class="section-description"><span class="step-section">STEP 4</span> : &ensp;&ensp;振替<b>後</b>の授業の情報を指定してください</h1>
        <notificationBox
          v-if="isCompletenessChecking && !isFourthCompleted"
          key="warning-fourth"
          type="warning"
          style="margin-top: 20px;"
          text="授業の種類，配布物の有無を入力してください"
        />
        <notificationBox
          v-else-if="isCompletenessChecking && isFourthCompleted"
          key="ok-fourth"
          type="ok"
          style="margin-top: 10px;"
          text="正しく入力されています"
        />
        <!--入力チェックの通知 終わり-->

        <!--オプション指定部分-->
        <reschedulingOptionForm :reservationOption="reservationOption"/>
        <!--オプション指定部分 終わり-->

      </section>
      <!--（教師の場合のみ）授業のオプションを指定する部分　終わり-->
      <el-button
        class="btn"
        @click="onConfirmButtonClicked()"
      >
        入力内容を確認する
      </el-button>
    </div>
  </div>
</template>

<script>
  import AutocompleteSelection from '../timetable/AutocompleteSelection'
  import DatePicker from 'vuejs-datepicker'
  import moment from 'moment'
  import NotificationBox from './NotificationBox'
  import ReschedulingOptionForm from './ReschedulingOptionForm'
  import {
    mapActions
  } from 'vuex'

  export default {
    data () {
      return {
        studentList: null,
        teacherList: null,
        selectedReservation: null,
        isOther: false,
        otherReservation: {
          date: '',
          startTime: '',
          endTime: '',
          receiver: 0
        },
        reservations: [],
        candidateDatetimes: [
          {
            date: '',
            mode: 'slot', // 'slot'または'range'
            startTime: '',
            endTime: '',
            duration: 0
          }
        ],
        reason: '',
        isCompletenessChecking: false,
        reservationOption: {
          reservationType: '通常',
          hasTest: false,
          reservationMessage: ''
        }
      }
    },
    name: 'reschedulingSenderForm',
    components: {
      'autocomplete': AutocompleteSelection,
      'datepicker': DatePicker,
      'notificationBox': NotificationBox,
      'reschedulingOptionForm': ReschedulingOptionForm
    },
    computed: {
      isFirstCompleted () {
        return (this.selectedReservation && !this.isOther) ||
                (this.isOther &&
                  this.otherReservation.receiver &&
                  this.otherReservation.date &&
                  this.otherReservation.startTime &&
                  this.otherReservation.endTime)
      },
      isSecondCompleted () {
        for (let candidate of this.candidateDatetimes) {
          if (!candidate.date || !candidate.startTime || !candidate.endTime) {
            return false
          }
        }
        return true
      },
      isThirdCompleted () {
        return !!this.reason
      },
      isFourthCompleted () {
        return this.$store.state.userInfo.user_type === 'teacher' &&
                this.reservationOption.reservationType !== null && this.has_test !== null
      },
      reservationDuration () {
        let calcMinutesDiff = (t1, t2) => {
          let tmpDate = '2018-01-01' // いつでもいい
          return (new Date(tmpDate + 'T' + t1).getTime() - new Date(tmpDate + 'T' + t2).getTime()) / 1000 / 60
        }
        if (this.selectedReservation && !this.isOther) {
          return calcMinutesDiff(this.selectedReservation.endTime, this.selectedReservation.startTime)
        } else if (this.isOther && this.otherReservation.date && this.otherReservation.startTime && this.otherReservation.endTime) {
          return calcMinutesDiff(this.otherReservation.endTime, this.otherReservation.startTime)
        } else {
          return 0
        }
      }
    },
    methods: {
      ...mapActions([
        'getReservations',
        'setReschedulingInfo',
        'getLectures'
      ]),
      moment: moment,
      parseDateTime (date, time = null) {
        date = date.split('-')
        if (time) {
          time = time.split(':')
          return new Date(date[0], date[1] - 1, date[2], time[0], time[1])
        } else {
          return new Date(date[0], date[1] - 1, date[2])
        }
      },
      disabledDate (date) {
        // 予約開始は本日より 24H 後から 2 ヶ月先まで
        let nowdt = new Date()
        nowdt.setDate(nowdt.getDate() + 1)
        let stdt = new Date(nowdt.getFullYear(), nowdt.getMonth(), nowdt.getDate(), 0, 0, 0)
        let enddt = new Date()
        enddt.setMonth(enddt.getMonth() + 1)
        return date < stdt || (!this.$store.state.userInfo.is_Sunday_user && date.getDay() === 0) || date > enddt
      },
      getWeekday (date) {
        return ['日', '月', '火', '水', '木', '金', '土'][date.getDay()]
      },
      addEmptyCandidate () {
        this.candidateDatetimes.push({
          date: '',
          mode: 'slot',
          startTime: '',
          endTime: '',
          duration: this.reservationDuration
        })
        this.$nextTick(() => {
          let list = document.getElementById('candidate-list')
          console.log(list)
          list.scrollTop = list.scrollHeight
        })
      },
      deleteCandidate (index) {
        this.candidateDatetimes.splice(index, 1)
      },
      onConfirmButtonClicked () {
        if (!this.selectedReservation.mailCheck) {
          alert('生徒様または講師様のメールアドレスがシステムに登録されていないため，授業振替依頼をご使用いただくことが出来ません\n究進塾事務局までご連絡ください')
          return
        }
        if (!this.isOther) {
          let st = this.selectedReservation.status
          if (st === 'temporal' || st === 'temp/temp' || st === 'trial') {
            alert('恐れ入りますが、短期利用者の振り替え依頼は究進塾事務局(info@kyushinjuku.com)へ、授業前日22時までにご連絡ください。')
            return
          }
          /*
          if (this.selectedReservation.receiverUserName.match('tanki')) {
            alert('恐れ入りますが、短期利用者の振り替え依頼は究進塾事務局(info@kyushinjuku.com)へ、授業前日22時までにご連絡ください。')
            return
          }
          */
        }
        if (this.isFirstCompleted && this.isSecondCompleted && this.isThirdCompleted) {
          // TODO: 確認ページへ
          this.setReschedulingInfo(this.makeReschedulingInfo())
          this.$router.push('/rescheduling/confirmation')
        } else {
          this.isCompletenessChecking = true
          alert('入力内容にエラーがあります！')
          window.scrollTo(0, 0)
        }
      },
      candidateStartTimeChanged (cand) {
        if (cand.mode === 'slot') {
          if (cand.startTime) {
            cand.endTime = moment(cand.startTime, 'HH:mm').add(this.reservationDuration, 'minutes').format('HH:mm')
          } else {
            cand.endTime = null
          }
        }
      },
      candidateEndTimeChanged (cand) {
        if (cand.mode === 'slot') {
          if (cand.endTime) {
            cand.startTime = moment(cand.endTime, 'HH:mm').add(-this.reservationDuration, 'minutes').format('HH:mm')
          } else {
            cand.startTime = null
          }
        }
      },
      reservationChanged () {
        console.log(this.selectedReservation)
        this.clearCandidateTimes()
        if (this.$store.state.userInfo.user_type === 'teacher') {
          if (this.selectedReservation) {
            this.reservationOption.reservationType = this.selectedReservation.type
            this.reservationOption.hasTest = this.selectedReservation.has_test
            this.reservationOption.reservationMessage = this.selectedReservation.message
          } else {
            this.reservationOption.reservationType = '通常'
            this.reservationOption.hasTest = false
            this.reservationOption.reservationMessage = ''
          }
        }
      },
      clearCandidateTimes () {
        for (let cand of this.candidateDatetimes) {
          cand.startTime = null
          cand.endTime = null
          cand.duration = this.reservationDuration
        }
      },
      getMaxStartTime (cand) {
        if (cand.mode === 'slot') {
          return moment('23:00', 'HH:mm').add(-this.reservationDuration + 1, 'minutes').format('HH:mm')
        } else if (cand.mode === 'range') {
          return moment(cand.endTime ? cand.endTime : '23:00', 'HH:mm').add(-this.reservationDuration + 1, 'minutes').format('HH:mm')
        } else {
          return ''
        }
      },
      getMinEndTime (cand) {
        if (cand.mode === 'slot') {
          return moment('10:00', 'HH:mm').add(this.reservationDuration - 1, 'minutes').format('HH:mm')
        } else if (cand.mode === 'range') {
          return moment(cand.startTime ? cand.startTime : '10:00', 'HH:mm').add(this.reservationDuration - 1, 'minutes').format('HH:mm')
        } else {
          return ''
        }
      },
      makeReschedulingInfo () {
        let sender = this.$store.state.userInfo.user_id
        let receiver = (this.selectedReservation && !this.isOther) ? this.selectedReservation.receiver : this.otherReservation.receiver
        let targetReservation = (this.selectedReservation && !this.isOther)
          ? this.selectedReservation
          : {
            date: this.otherReservation.date,
            startTime: this.otherReservation.startTime + ':00',
            endTime: this.otherReservation.endTime + ':00'
          }
        return {
          sender: sender,
          receiver: receiver,
          targetReservation: targetReservation,
          candidateDatetimes: this.candidateDatetimes,
          reason: this.reason,
          reservationOption: this.reservationOption
        }
      },
      check_tankiuser () {
        let st = this.$store.state.userInfo.user_status
        if (st === 'temporal' || st === 'temp/temp' || st === 'trial') {
          return true
        } else {
          return false
        }
        /*
        if (this.$store.state.userInfo.user_name.match('tanki')) {
          return true
        } else {
          return false
        }
        */
      }
    },
    mounted () {
      this.getReservations({user_id: this.$store.state.userInfo.user_id})
      .then(() => {
        let filteredList = this.$store.state.reservations.filter(
          (reservation) => {
            return this.parseDateTime(reservation.date) > new Date()
          })
        filteredList.sort(
          (a, b) => {
            let dateA = this.parseDateTime(a.date, a.start_time)
            let dateB = this.parseDateTime(b.date, b.start_time)
            if (dateA < dateB) {
              return -1
            } else if (dateA > dateB) {
              return 1
            } else {
              return 0
            }
          })
        for (let r of filteredList) {
          let selectedDate = this.parseDateTime(r.date, r.start_time)
          if (selectedDate.getDay() === 1) {
            selectedDate.setDate(selectedDate.getDate() - 2)
          } else {
            selectedDate.setDate(selectedDate.getDate() - 1)
          }
          let limitDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 22, 0, 0)
          this.reservations.push({
            id: r.id,
            date: r.date,
            startTime: r.start_time,
            endTime: r.end_time,
            type: r.reservation_type,
            has_test: r.has_test,
            message: r.message,
            receiver: (this.$store.state.userInfo.user_type === 'teacher') ? r.student.id : r.teacher.id,
            receiverUserName: r.student.user_name,
            text: ((this.$store.state.userInfo.user_type === 'teacher' ? r.student.fullname + ' 様' : r.teacher.fullname + ' 先生')) + '　' + r.date.replace(/-/g, '/') + '　' + r.start_time.slice(0, -3) + ' 〜 ' + r.end_time.slice(0, -3),
            expireCheck: new Date() > limitDate,
            mailCheck: r.student.mail_address != null && r.teacher.mail_address != null,
            status: r.student.user_status
          })
        }
      })
      .catch((err) => {
        console.log(err)
      })
      this.getLectures({})
      .then(() => {
        if (this.$store.state.userInfo.user_type === 'teacher') {
          this.studentList = this.$store.state.lectureInfo.filter((lect, index, self) => {
            return this.$store.state.userInfo.user_id === lect.teacher.id && (/norm/.test(lect.student.status))
            // return this.$store.state.userInfo.user_id === lect.teacher.id && !(/^tanki_/.test(lect.student.user_name))
          }).map((lect, index, self) => {
            return lect.student
          })
        } else if (this.$store.state.userInfo.user_type === 'student') {
          this.teacherList = this.$store.state.lectureInfo.filter((lect, index, self) => {
            return this.$store.state.userInfo.user_id === lect.student.id
          }).map((lect, index, self) => {
            return lect.teacher
          })
        }
      })
      .catch((err) => {
        console.log(err)
      })
      if (this.$store.state.reschedulingInfo) {
        let reschedulingInfo = this.$store.state.reschedulingInfo
        if (reschedulingInfo.targetReservation.id) {
          this.selectedReservation = reschedulingInfo.targetReservation
          this.isOther = false
        } else {
          this.selectedReservation = null
          this.isOther = true
          this.otherReservation = reschedulingInfo.targetReservation
          this.otherReservation.receiver = reschedulingInfo.receiver
        }
        this.candidateDatetimes = reschedulingInfo.candidateDatetimes
        this.reason = reschedulingInfo.reason
        if (this.$store.state.userInfo.user_type === 'teacher') {
          this.reservationOption = reschedulingInfo.reservationOption
        }
      }
    }
  }
</script>

<style lang="css" scoped>
  #reschedulingSenderForm {
    text-align: center;
    font-family: "メイリオ", "ヒラギノ丸ゴ ProN", 'sans-serif', 'Avenir','Helvetica Neue','Helvetica','Arial','Hiragino Sans','ヒラギノ角ゴシック',YuGothic,'Yu Gothic','メイリオ', Meiryo,'ＭＳ Ｐゴシック','MS PGothic', 'sans-serif';
    margin-bottom: 50px;
    color:#5A5A5A;
  }
  .header {
    background-color: #0065B3;
    color: white;
    text-align: center;
    font-size: 20px;
    margin: 25px auto 40px;
    max-width: 800px;
    padding: 4px;
  }
  .section {
    border-bottom: solid 2px white;
    text-align: center;
    margin: 10px 5% 10px 5%;
    padding-bottom: 20px;
  }
  .section-description {
    font-size: 16px;
    border-bottom: solid 1px #0065B3;
    border-left: solid 8px #0065B3;
    text-align: left;
    margin-bottom: 30px;
    padding-left: 20px;
    width: 780px;
    margin: auto;
  }
  .step-section {
    font-weight: bolder;
    color: #0065B3;
    font-family: 'Arial Black';
  }
  #reservation-list, #candidate-list {
    text-align: center;
    overflow: auto;
    max-height: 320px;
    max-width: 500px;
    margin: 10px auto 10px auto;
  }
  .list-item {
    text-align: left;
    margin-bottom: 5px;
  }
  .list-item-reservation {
    border-bottom: solid 1px gray;
    padding-left: 5px;
  }
  #other-reservation-box {
    vertical-align: middle;
    text-align: left;
    margin: auto;
    max-width: 500px;
    margin-top: 50px;
  }
  #other-reservation-box > div{
    margin: 5px 0 5px 3%;
  }
  .vdp-datepicker {
    display: inline-block;
  }
  .candidate-box {
    border: solid 2px #0065b3;
    margin: 10px 0 10px 0;
  }
  .candidate-caption {
    background-color: #0065b3;
    color: white;
    font-size: 18px;
    padding-left: 1%;
    padding-right: 1%;
  }
  .candidate-caption-label {
    display: inline-block;
    text-align: left;
    width: 20%;
    margin: auto;
  }
  .candidate-caption-button {
    display: inline-block;
    text-align: right;
    width: 78%;
  }
  .candidate-content {
    margin: 5px 0 5px 3%;
  }
  .btn {
    margin: 5px 0 5px 0;
  }
  .text-area {
    text-align: left;
    margin: 10px auto;
    max-width: 500px;
  }
  #option-box {
    text-align: center;
    max-width: 500px;
    margin: 10px auto;
    border: solid 1px black;
  }
  .option-content {
    text-align: left;
  }
  .notificationBox {
    text-align: left;
    max-width: 500px;
    margin: auto;
  }
  .messagetext{
    position: relative;
    width: 60%;
    margin: 2em auto;
    text-align: left;
    padding: 25px 10px 7px;
    border: solid 2px #FFC107;
    margin-top: 60px;
  }
  .messagetext .box-title {
    position: absolute;
    display: inline-block;
    top: -2px;
    left: -2px;
    padding: 0 9px;
    margin: 2px;
    height: 25px;
    line-height: 25px;
    vertical-align: middle;
    font-size: 20px;
    background: #FFC107;
    color: #000000;
    font-weight: bold;
  }
  .messagetext p {
    font-weight: bold;
    margin: 0;
    padding: 0 50px;
  }
</style>



// WEBPACK FOOTER //
// ReschedulingSenderForm.vue?503fc589